/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateEmployeeDataViewModel } from "../types/UpdateEmployeeDataViewModel.ts";
import { eEmployeeTypeSchema } from "./eEmployeeTypeSchema.ts";

export const updateEmployeeDataViewModelSchema = z.object({
  postId: z
    .number()
    .int()
    .describe("ID do cargo do funcionário. Opcional.")
    .nullish(),
  codeBadge: z.string().describe("Código do crachá do funcionário.").nullish(),
  dateStart: z
    .string()
    .datetime()
    .describe("Data de início do vínculo empregatício. Opcional.")
    .nullish(),
  dateFinish: z
    .string()
    .datetime()
    .describe("Data de encerramento do vínculo empregatício. Opcional.")
    .nullish(),
  type: z.optional(
    z
      .lazy(() => eEmployeeTypeSchema)
      .describe("0 = Internal | 1 = External | "),
  ),
  serviceRequestNotification: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o funcionário recebe notificações de requisições de serviço.",
      ),
  ),
}) as unknown as ToZod<UpdateEmployeeDataViewModel>;
